import React, { useEffect, useRef, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import ReactToPrint from "react-to-print";
import DateTimeSearch from "./DateTimeSearch";
import GateLogPicture from "./GateLogPicture";
import { handleGetRequest } from "../../services/GetTemplate";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { handlePostRequest } from "../../services/PostTemplate";

function GateLogs() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const { companyId } = useParams();
  const componentRef = useRef();
  const [lazyState, setLazyState] = useState({
    first: 0,
    rows: 15,
    page: 0,
  });
  const [isOnFiltered, setisOnFiltered] = useState(false);
  const [filterParams, setfilterParams] = useState({});

  const getAllGateLogs = async () => {
    setLoading(true);

    try {
      const params = new URLSearchParams({
        page: lazyState.page,
        size: lazyState.rows,
        ...lazyState.filters,
      });

      const res = await handleGetRequest(`gateLog/all/${companyId}?${params}`);
      setData(res?.data?.rows);
      setTotalRecords(res?.data?.totalRecords);
    } catch (error) {
      console.error("Error fetching data:", error);
      // Handle error as needed
    } finally {
      setLoading(false);
    }
  };

  const getFilteredGateLogs = async () => {
    try {
      const params = new URLSearchParams({
        page: lazyState.page,
        size: lazyState.rows,
      });
      const res = await handlePostRequest(
        filterParams,
        `gateLog/search?${params}`
      );
      setData(res?.data?.rows);
      setTotalRecords(res?.data?.totalRecords);
    } catch (error) {
      console.error("Error fetching data:", error);
      // Handle error as needed
    }
  };

  useEffect(() => {
    if (isOnFiltered && lazyState) {
      getFilteredGateLogs();
    }
    if (!isOnFiltered) {
      getAllGateLogs();
    }
  }, [lazyState, companyId]);

  const onPage = (event) => {
    setLazyState({ ...lazyState, ...event });
  };

  const onSort = (event) => {
    setLazyState({ ...lazyState, ...event });
  };

  const onFilter = (data, fData) => {
    setData(data?.rows || []);
    setTotalRecords(data?.totalRecords || 0);
    setfilterParams(fData);
    setisOnFiltered(true);
  };

  const picTemplate = (rowData) => {
    return <GateLogPicture gateLogId={rowData?.gateLogId} />;
  };

  return (
    <>
      <DateTimeSearch
        companyId={companyId}
        onFilter={onFilter}
        lazyState={lazyState}
      />
      <div>
        <div className="card">
          <div className="Down__Btn">
            <ReactToPrint
              trigger={() => (
                <Button
                  className="Btn__Dark"
                  label="Print"
                  icon="pi pi-print"
                />
              )}
              content={() => componentRef.current}
            />
          </div>
          <div ref={componentRef}>
            <DataTable
              header="All Gate Logs"
              scrollable
              lazy
              scrollHeight="400px"
              style={{ minWidth: "50rem" }}
              tableStyle={{ minWidth: "50rem" }}
              dataKey="gateId"
              loading={loading}
              paginator
              rows={lazyState.rows}
              totalRecords={totalRecords}
              first={lazyState.first}
              onPage={onPage}
              onSort={onSort}
              value={data}
              emptyMessage="No data found."
            >
              <Column field="ocrName" header="Name" />
              <Column field="ocrFathername" header="Father Name" />
              <Column field="ocrCnic" header="CNIC" />
              <Column field="gateName" header="Gate Name" />
              <Column field="timestamp" header="Date and Time" />
              <Column field="gateLogId" body={picTemplate} header="Picture" />
            </DataTable>
          </div>
        </div>
      </div>
    </>
  );
}

export default GateLogs;
